import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENT_ID,  // Client ID from App Config
        authority: `https://${process.env.REACT_APP_B2C_TENANT}.b2clogin.com/${process.env.REACT_APP_B2C_TENANT}.onmicrosoft.com/${process.env.REACT_APP_B2C_SIGNIN_POLICY}`, // Dynamic authority
        redirectUri: process.env.REACT_APP_REDIRECT_URI, // Pulled from App Config (for each environment)
        postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_REDIRECT_URI,  // Pulled from App Config
        knownAuthorities: [`${process.env.REACT_APP_B2C_TENANT}.b2clogin.com`], // Known authority
        navigateToLoginRequestUrl: false, // Prevent navigation to original request URL after login
    },
    cache: {
        cacheLocation: "localStorage",  // Cache tokens in localStorage for persistence
        storeAuthStateInCookie: true,   // Enable for better cross-tab and mobile support
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error: console.error(message); break;
                    case LogLevel.Info: console.info(message); break;
                    case LogLevel.Verbose: console.debug(message); break;
                    case LogLevel.Warning: console.warn(message); break;
                    default: console.log(message); break;
                }
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Error 
        },
        // Improve PWA and mobile experience
        allowNativeBroker: false, // Disable native broker for better PWA experience
        windowHashTimeout: 9000, // Increase timeout for better mobile experience
        iframeHashTimeout: 9000,
        // Improve cross-tab communication
        allowRedirectInIframe: false,
        navigateFrameWait: 0
    }
};

// Request scopes for login - IMPORTANT: include all necessary scopes
export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        `https://${process.env.REACT_APP_B2C_TENANT}.onmicrosoft.com/${process.env.REACT_APP_API_CLIENT_ID}/access_as_user`
    ]
};

// Additional config for token acquisition
export const apiRequest = {
    scopes: [
        `https://${process.env.REACT_APP_B2C_TENANT}.onmicrosoft.com/${process.env.REACT_APP_API_CLIENT_ID}/access_as_user`
    ]
};
